/* globals jQuery */
import 'fitvids.1.1.0'

import {initAlert} from './alert-bar.js';
import responsiveNav from './responsive-nav.js'
import './jquery.accordion.js'
import './jquery.tabs.js'

(($) => {

    //INITIATE ALERT
    initAlert();

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            desktopEms: '72em', // size of screen for desktop menu, should match less media query for @desktop-menu
            wrapperSelector: '.main-nav',
            navType: 'offCanvas',
            closeOnOutsideClick: true
        });
    }

    const sideNav = document.querySelector('nav.side-nav');
    if( sideNav ){
        responsiveNav(sideNav,{
            desktopEms: '64em', // size of screen for desktop menu, should match less media query for @desktop-menu
            wrapperSelector: '.side-nav',
            menuButtonSelector: '.side-nav-trigger',
            dropdownSelector: '.side-nav-wrapper',
            navType: 'dropdown',
            closeOnOutsideClick: true
        });
    }

    const sideResources = document.querySelector('.side-resources');
    if( sideResources ){
        responsiveNav(sideResources,{
            desktopEms: '64em', // size of screen for desktop menu, should match less media query for @desktop-menu
            wrapperSelector: '.side-resources',
            menuButtonSelector: '.side-resources-trigger',
            dropdownSelector: '.side-resources-wrapper',
            navType: 'dropdown',
            closeOnOutsideClick: true
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids();

    // Accordions
	$('dl.accordion').accordion();
    // Tabs
	$('.tabs').tabs();

    //SEARCH DIALOG
    // Get all buttons with the class 'js-show-video-dialog'
    const searchDialogButton = document.querySelector('.open-search');
    const searchDialog = document.getElementById('search-popup');
    const searchDialogCloseButton = searchDialog.querySelector(".close-search");

    // "Show the dialog" button opens the dialog modally
    searchDialogButton.addEventListener('click', () => {
        searchDialog.showModal();
        document.body.classList.add('no-scroll');
        document.querySelector('.site-wrapper').setAttribute('inert', '');
    });
    // "Close" button closes the dialog
    searchDialogCloseButton.addEventListener("click", () => {
        searchDialog.close();
    });
    searchDialog.addEventListener('close', () => {
        document.body.classList.remove('no-scroll');
        document.querySelector('.site-wrapper').removeAttribute('inert');
        searchDialogButton.focus();
    });


    //Content Dialog - profile grid
    // Get all buttons with the class 'js-show-video-dialog'
    const contentDialogButtons = document.querySelectorAll('.js-open-dialog');
    // Loop through each button
    contentDialogButtons.forEach(showButton => {

        // Get the next element, which is assumed to be the dialog
        let dialog = showButton.nextElementSibling;
        let closeButton = dialog.querySelector(".js-close-dialog");

        // "Show the dialog" button opens the dialog modally
        showButton.addEventListener('click', () => {
            dialog.showModal();
        });
        // "Close" button closes the dialog
        closeButton.addEventListener("click", () => {
            dialog.close();
        });

    });


    // Gauge
	var val = $('.gauge__main').data('val');
	var deg = (val * 180) / 100;
	$('.gauge__pointer').css('transform', 'rotate('+ deg +'deg)');

})(jQuery)
